if (!customElements.get('oh-lifestyle-carousel')) {
  customElements.define('oh-lifestyle-carousel', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        this.initialize();
      });
    }

    initialize() {
      if (this.abort) return;
      this.viewport = this.querySelector('.lifestyle-carousel__viewport');
      if (!this.viewport) return;
      this.controls = this.querySelector('.lifestyle-carousel__controls');
      this.track = this.querySelector('.lifestyle-carousel__track');
      this.thumb = this.querySelector('.lifestyle-carousel__thumb');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.queueUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.viewport.addEventListener('scroll', this.queueUpdate, { ...options, passive: true });
      window.addEventListener('resize', this.queueUpdate, options);
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const cards = this.viewport.children;
        if (!cards.length) return;
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.viewport).columnGap);
        const direction = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;
        this.viewport.scrollBy({ left: step * Number(button.dataset.direction) * direction, behavior: this.scrollBehavior });
      }, options));
      this.viewport.addEventListener('focusin', event => {
        const card = event.target.closest('.lifestyle-carousel__card');
        if (card) this.reveal(card, this.scrollBehavior);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = [...this.viewport.children].find(item => item.dataset.blockId === event.detail?.blockId);
        if (card) this.reveal(card, 'instant');
      }, options);
      this.observer = new ResizeObserver(this.queueUpdate);
      this.observeSizes();
      this.mutations = new MutationObserver(() => {
        this.observeSizes();
        this.queueUpdate();
      });
      this.mutations.observe(this.viewport, { childList: true, subtree: true, characterData: true });
      this.dataset.ready = '';
      this.update();
    }

    get scrollBehavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    }

    observeSizes() {
      this.observer.disconnect();
      this.observer.observe(this.viewport);
      if (this.track) this.observer.observe(this.track);
      [...this.viewport.children].forEach(card => this.observer.observe(card));
    }

    reveal(card, behavior) {
      const bounds = this.viewport.getBoundingClientRect();
      const item = card.getBoundingClientRect();
      const delta = item.left < bounds.left ? item.left - bounds.left : item.right > bounds.right ? item.right - bounds.right : 0;
      if (delta) this.viewport.scrollBy({ left: delta, behavior });
    }

    update() {
      const viewport = this.viewport;
      const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const overflowing = maximum > 1;
      const position = Math.min(maximum, Math.max(0, Math.abs(viewport.scrollLeft)));
      this.controls.hidden = !overflowing || (!this.track && !this.buttons.length);
      this.buttons.forEach(button => {
        button.disabled = !overflowing || (Number(button.dataset.direction) < 0 ? position <= 1 : position >= maximum - 1);
      });
      if (!this.track || !this.thumb || !overflowing) return;
      const width = this.track.clientWidth;
      const thumbWidth = Math.min(width, Math.max(24, width * viewport.clientWidth / viewport.scrollWidth));
      const progress = maximum ? position / maximum : 0;
      const rtl = getComputedStyle(viewport).direction === 'rtl';
      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${(width - thumbWidth) * (rtl ? 1 - progress : progress)}px)`;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.mutations?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controls?.setAttribute('hidden', '');
      delete this.dataset.ready;
    }
  });
}
